import {
  SubscriptionTierInTable,
  subscriptionHeaders,
} from '@upright/common/activities/contact-forms/company-subscription/subscription-tiers';
import { NiceButton } from '@upright/ui/common/generic/components/buttons/nice-button';
import { usePushAnonymousGtmEvent } from '@upright/ui/common/generic/components/google-tag-manager/use-push-gtm-event';
import { CustomGtmEvent } from '@upright/ui/common/generic/components/google-tag-manager/use-push-gtm-event/payloads';
import { tabletOrWider } from '@upright/ui/common/generic/layout/breakpoint-utils';
import styled, { css } from 'styled-components';

interface Props {
  onTierClick: (tier: SubscriptionTierInTable) => void;
}

export const SubscriptionTableHead = (props: Props) => {
  const pushGtmEvent = usePushAnonymousGtmEvent();

  return (
    <thead>
      <tr>
        <th />
        {subscriptionHeaders.map(category => (
          <th key={category.name}>
            <HeaderCell>
              <p className="subscription-table-header-text">{category.name}</p>
              <p className="subscription-table-small-text">{category.description}</p>
              <NiceButton
                theme="dark"
                isOutlined={category.buttonOutlined}
                onClick={() => {
                  pushGtmEvent({ event: CustomGtmEvent.UA_BOOK_COMPANY_DEMO_CLICK, data: { tier: category.name } });
                  props.onTierClick(category.name);
                }}
              >
                {category.buttonText}
              </NiceButton>
            </HeaderCell>
          </th>
        ))}
      </tr>
    </thead>
  );
};

const HeaderCell = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2em 1em;
  ${tabletOrWider(css`
    > p,
    a {
      height: 32px;
    }
  `)}
`;
